/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash'

type ArbitraryObject = Record<PropertyKey, any>

export const whatChangedBetween = (
  changedObject: ArbitraryObject,
  initial: ArbitraryObject
): ArbitraryObject => {
  const didValueChanged = (key: string, currentValue: any) =>
    initial[key] !== currentValue
  return _.pickBy(changedObject, (value: any, key: string) => {
    return didValueChanged(key, value)
  })
}

/**
 * isUndefinedorNull determines if specified @param value is null or undefined
 * @param {any} value: any description
 * @returns {boolean} - True if the value is undefined or null
 */

export function isUndefinedOrNull(value: any): boolean {
  return _.isNull(value) || _.isUndefined(value)
}

/**
 * Short hand for !isUndefinedOrNull
 */

export function assigned(value: any): boolean {
  return !isUndefinedOrNull(value)
}
